import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { assinarSessao, lerSessao } from "./sessao";
import { entrar, sair } from "./authService";

const AuthContext = createContext(null);

const usuarioAtual = () => lerSessao()?.usuario ?? null;

export function AuthProvider({ children }) {
  // motivo: por que a sessao acabou ("expirada"), para avisar no login.
  const [estado, setEstado] = useState(() => ({ usuario: usuarioAtual(), motivo: null }));

  useEffect(() => {
    const atualizar = ({ motivo }) => {
      const usuario = usuarioAtual();
      // A renovacao do token tambem notifica: sem troca de usuario, nada muda.
      setEstado((atual) =>
        atual.usuario?.login === usuario?.login && atual.motivo === motivo
          ? atual
          : { usuario, motivo }
      );
    };

    const cancelar = assinarSessao(atualizar);
    // A sessao pode ter mudado entre o primeiro render e a assinatura.
    atualizar({ motivo: null });
    return cancelar;
  }, []);

  const valor = useMemo(
    () => ({
      usuario: estado.usuario,
      autenticado: Boolean(estado.usuario),
      motivo: estado.motivo,
      entrar,
      sair,
    }),
    [estado]
  );

  return <AuthContext.Provider value={valor}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const contexto = useContext(AuthContext);
  if (!contexto) {
    throw new Error("useAuth precisa estar dentro de <AuthProvider>.");
  }
  return contexto;
}
